import { toast } from "react-toastify";
import { postLoginInstance } from "../../utils";
import { API_LIMIT, durationObj, MAX_LIMIT, START_PAGE } from "../../utils/Constant";
import { getAllSsoData, getAllSsoViewUserData, getAllTypesData, getSsoDetails } from "./SsoAction";
import { getAllListData } from "../MasterCategory/MasterCategoryAction";
import { filterVerifiedItems } from "../../utils/ReusableFunctions";

export const getAllTypeApi = (ctx = null) => {
  const { verifyUrl = false } = ctx?.state ?? {};
  return function (dispatch, getState) {

    return postLoginInstance.get(`sso/types?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${ctx?.state.pageSize || (ctx?.state.isAddContent ? MAX_LIMIT : API_LIMIT)}&pageNumber=${ctx?.state.currentPage || START_PAGE}`)
      .then((res) => {

        // return ctx.setState({ dummyData: res.data.data ,});

        dispatch(getAllTypesData(res.data.data, ctx?.state.currentPage || START_PAGE));
        let options = filterVerifiedItems(res.data.data.list).map((item) => ({
          value: item.uuid,
          label: item.type
        }));

        ctx.setState({ typesOptions: options })
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      })
  }

};
export const getAllToolsApi = (ctx = null) => {
  postLoginInstance.get("tools?pageNumber=1&pageSize=1000")
    .then((res) => {
      let options = filterVerifiedItems(res.data?.data?.list).map((item) => ({
        value: item.uuid,
        label: item.toolName
      }));
      ctx.setState({ toolsOption: options })
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message || "Something went wrong")
    })
};
export const getAllPersonalizationCalendarApi = (ctx = null) => {
  postLoginInstance.get("calender")
    .then((res) => {
      let options = filterVerifiedItems(res.data?.data?.list).map((item) => ({
        value: item.uuid,
        label: item.calenderName
      }));
      ctx.setState({ personalizationCalendarOptions: options })
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message || "Something went wrong")
    })
};

export const getPersonalizationCategoryApi = (ctx = null, onHide = null) => {
  const { verifyUrl = false } = ctx?.state ?? {};
  return function (dispatch, getState) {
    return postLoginInstance
      .get(
        `personalization/category?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${MAX_LIMIT}&pageNumber=${START_PAGE
        }`
      )
      .then((res) => {
        const option = filterVerifiedItems(res.data.data.list).map((item) => ({
          label: item.categoryName,
          value: item.uuid
        }));
        ctx.setState({
          personalizationCategoryOptions: option
        })

      }).catch((error) => {
        toast.error(error?.response?.data?.message || 'Something went wrong.');
      })
  };
};

export const getAllSsoPartnersApi = async (ctx = null, onHide = null) => {
  const { verifyUrl = false } = ctx?.state ?? {};
  return postLoginInstance.get(`sso?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${MAX_LIMIT}&pageNumber=${START_PAGE}`)
    .then((res) => {
      let options = filterVerifiedItems(res.data.data.list).map((item) => ({
        label: item.companyName,
        value: item.id
      }));
      ctx?.setState({
        ssoPartnersOptions: options
      });
      if (!ctx) {
        onHide?.();
      }
      return options;
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message || 'Something went wrong.');
    });
}


export const getAllSsoApi = (ctx = null) => {
  ctx?.setState?.({ isLoading: true })
  return function (dispatch, getState) {
    const params = new URLSearchParams(ctx?.props?.location?.search);
    const searchValue = params.get("search") || "";
    const verifyUrl = params.get("isVerified") ? `isVerified=${params.get("isVerified")}` : "";
    const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;
      const page = parseInt(params.get("page"), 10) || START_PAGE;

    return postLoginInstance.get(`sso?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${size || API_LIMIT}&pageNumber=${page}${searchValue && `&searchValue=${searchValue}`}`)
      .then((res) => {

        // return ctx.setState({ dummyData: res.data.data ,});
        dispatch(getAllSsoData(res.data.data, ctx?.state.currentPage || START_PAGE));

      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      }).finally(() => {
        ctx?.setState?.({ isLoading: false })
      })
  }

};

export const getSsoForOptionsApi = (ctx = null) => {
  postLoginInstance.get(`sso`)
    .then((res) => {
      let options = filterVerifiedItems(res.data.data.list).map((item) => ({
        label: item.companyName,
        value: item.uuid
      }));
      ctx.setState({
        ssoOptions: options
      });
    });
}
export const getDetailsSsoApi = (path, ctx, isEdit = false, plansOptions = []) => {
  console.log(ctx)

  return postLoginInstance.get(`${path}/${ctx.props?.match?.params?.uuid}`)
    .then((res) => {

      const getValue = (value) => {
        return Array.isArray(value) ? value : value?.split(',') || []
      }

      const data = res.data.data;
      const subPremiumPlans = plansOptions.find(plan => plan.uuid === data?.premiumPlan?.uuid)?.subPremiumPlan || [];
      const subPremiumPlanVariations = subPremiumPlans.find(subPlan => subPlan.uuid === data?.subPremiumPlan?.uuid)?.subPremiumPlanVariation || [];

      const subPremiumPlanOptions = (plansOptions || []).reduce((acc, plan) => {
                  if (Array.isArray(plan?.subPremiumPlan) && plan.subPremiumPlan.length > 0) {
                      const mappedSubPlans = plan.subPremiumPlan.map(subPlan => ({
                          value: subPlan.uuid,
                          label: subPlan.name,
                          variations: subPlan.subPremiumPlanVariation.map(variation => ({
                              value: variation.uuid,
                              label: durationObj[variation.resetInDays],
                          })),
                      }));
                      acc.push(...mappedSubPlans);
                  }
                  return acc;
              }, [])

      let modules = getValue(data.modules);
      let processedModules = modules.map(item => {
        return {
          ...item,
          masterSsoPartnerModuleUuid: item?.masterSsoPartnerModule?.uuid || "",
          uuids: getValue(item?.uuids)?.map(i => i?.uuid) || [],
          eventOrganizer: getValue(item?.eventOrganizer)?.map(i => i?.uuid) || [],
          eventAmcs: getValue(item?.eventAmcs)?.map(i => i?.uuid) || [],
          uploadSections: getValue(item?.uploadSections)?.map(i => i?.uuid) || [],
          personalizationCategory: getValue(item?.personalizationCategory)?.map(i => i?.uuid) || [],
        }
      });


      return isEdit ? (ctx.setState({
        data: {
          ...ctx.state.data,
          isTfpContentVisible: data.isTfpContentVisible || false,
          companyName: data.companyName,
          emailAddress: data.emailAddress,
          mobileNumber: data.mobileNumber,
          websiteLink: data.websiteLink,
          logo: data.companyLogo,
          type: data.ssoPartnerType?.uuid || "",
          partnerType: data.type,
          loginLeftImage: data.loginLeftImage,
          favicon: data.favicon,
          pageTitle: data.pageTitle,
          pageDescription: data.pageDescription,
          modules: processedModules,
          contentCreators: getValue(data.contentCreators)?.map(item => item.uuid) || [],
          amcs: getValue(data.amcs)?.map(item => item.uuid) || [],
          defaultPlanConfiguration: {
            premiumPlanUuid: data.premiumPlan?.uuid,
            subPremiumPlanUuid: data.subPremiumPlan?.uuid,
            subPremiumPlanVariationUuid: data.subPremiumPlanVariation?.uuid,
          },
          planConfiguration: {
            allowSubscriptionPlanPage: data.allowSubscriptionPlanPage,
            subscriptionPlanPageLink: data.subscriptionPlanPageLink,
            allowedPremiumPlans: subPremiumPlanOptions.filter(subPlan => getValue(data.allowedSubPremiumPlans).includes(subPlan.value)).map(subPlan => ({
              subPremiumPlanUuid: subPlan.value,
              subPremiumPlanVariationUuids: subPlan.variations.filter(variation => getValue(data.allowedSubPremiumPlanVariations).includes(variation.value)).map(variation => variation.value),
            })),
            isTFPAllowed: (data.allowedSubPremiumPlans || data.subscriptionPlanPageLink) ? Boolean(data.allowedSubPremiumPlans) : null,
          },
          adminPanelConfiguration: {
            allowPartnerAdminPanel: data.allowPartnerAdminPanel,
            allowPartnerAdminUserDetails: data.allowPartnerAdminUserDetails,
          },
          ssoConfiguration: {
            isParentChildrenAllowed: data.allowParentChildren,
            canUpdateProfile: data.canUserUpdateProfile,
            allowChildrenMemebershipPage: data.allowChildrenMemebershipPage,
            isEditProfileAllowed: data.isEditProfileAllowed,
            isEditCompanyDetailsAllowed: data.isEditCompanyDetailsAllowed,
            isCobrandTemplateSelectable: data.isCobrandTemplateSelectable,
            isDefaultTemplateSelectable: data.isDefaultTemplateSelectable,
            isCustomTemplateAllowed: data.isCustomTemplateAllowed,
          },
          subDomainConfiguration: {
            favicon: data.favicon,
            pageTitle: data.pageTitle,
            pageDescription: data.pageDescription,
          },
          companyLogoConfiguration: {
            companyLogoVisibility: data.companyLogoVisibility,
            companyLogoText: data.companyLogoText,
            where: data.companyLogoText ? "both" : data.companyLogoVisibility ? "self" : "",
            logoPosition: data.logoPosition,
          },
          theme: data.theme || {}

        },
        subPremiumPlans: subPremiumPlans,
        subPremiumPlanVariations: subPremiumPlanVariations,

      })) : ctx.setState({ data });


    })
    .catch((err) => {
      console.log('Eroorr', err)
      toast.error(err?.response?.data?.message || 'Something went wrong.');
    })

}
export const getAllCreatorApi = (ctx, type = "content") => {
  const newUrl = ctx?.state?.isUserPage ? 'contentCreator' : `contentCreator?type=${type}`;

  return postLoginInstance.get(newUrl)
    .then((res) => {
      let options = filterVerifiedItems(res.data.data.list).map((item) => ({
        label: item.contentCreatorName,
        value: item.uuid,
      }));
      if (type === "content") {
        ctx.setState({
          creatorList: options
        });
      } else {
        ctx.setState({
          organizerList: options
        });
      }
    })

};
export const getAllAmcSsoApi = (ctx = null, onHide = null) => {
  const { verifyUrl = false } = ctx?.state ?? {};
  return function (dispatch, getState) {
    return postLoginInstance
      .get(
        `amc?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${ctx?.state.pageSize || (ctx?.state.isAddContent ? MAX_LIMIT : API_LIMIT)}&pageNumber=${ctx?.state.currentPage || START_PAGE}`
      )
      .then((res) => {
        if (ctx?.state.isAddContent) {
          let options = filterVerifiedItems(res.data.data.list).map((item) => ({
            label: item.amcName,
            value: item.uuid
          }));


          ctx.setState({
            amcOption: options
          });
        } else {
          dispatch(
            getAllListData(res.data.data, ctx?.state.currentPage || START_PAGE)
          );
        }

        if (!ctx) {
          onHide();
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || 'Something went wrong.');
      });
  };
};
export const getSsoViewUserApi = (ctx) => {


  ctx?.setState?.({ isLoading: true })
  return function (dispatch, getState) {
    return postLoginInstance.get(`sso/users/dashboard?ssoPartnerId=${ctx?.props?.location?.state?.ssoPartnerId || ctx.props.match?.params.id}&pageSize=${ctx?.state.pageSize || API_LIMIT}&pageNumber=${ctx?.state.currentPage || START_PAGE}${ctx.state.search && `&searchValue=${ctx.state.search}`}`)
      .then((res) => {

        // return ctx.setState({ dummyData: res.data.data ,});
        dispatch(getAllSsoViewUserData(res.data.data, ctx?.state.currentPage || START_PAGE));
        ctx?.setState?.({ isLoading: false })
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      }).finally(() => {
        ctx?.setState?.({ isLoading: false })
      })
  }

};
export const getAllModulesApi = (ctx = null) => {
  const { verifyUrl = false } = ctx?.state ?? {};
  return function (dispatch, getState) {

    return postLoginInstance.get(`sso/master-modules?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${ctx?.state.pageSize || (ctx?.state.isAddContent ? MAX_LIMIT : API_LIMIT)}&pageNumber=${ctx?.state.currentPage || START_PAGE}`)
      .then((res) => {
        ctx.setState(() => {
          return {
            modulesList: res.data?.data?.list || [],
          };
        });
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      })
  }
};